/**
 * Custom hooks for shared collection dashboard data
 */

import { useQuery } from '@tanstack/react-query';
import { sharedDashboardService } from '../services/sharedDashboardService';

export function useSharedDashboardStats(userId) {
  return useQuery({
    queryKey: ['shared-dashboard', userId, 'stats'],
    queryFn: () => sharedDashboardService.getDashboardStats(userId),
    enabled: !!userId,
    staleTime: 1000 * 60
  });
}

export function useSharedBottlesByType(userId) {
  return useQuery({
    queryKey: ['shared-dashboard', userId, 'byType'],
    queryFn: () => sharedDashboardService.getBottlesByType(userId),
    enabled: !!userId,
    staleTime: 1000 * 60
  });
}

export function useSharedBottlesByCountry(userId) {
  return useQuery({
    queryKey: ['shared-dashboard', userId, 'byCountry'],
    queryFn: () => sharedDashboardService.getBottlesByCountry(userId),
    enabled: !!userId,
    staleTime: 1000 * 60
  });
}

export function useSharedRecentBottles(userId, limit = 5) {
  return useQuery({
    queryKey: ['shared-dashboard', userId, 'recent', limit],
    queryFn: () => sharedDashboardService.getRecentBottles(userId, limit),
    enabled: !!userId,
    staleTime: 1000 * 60
  });
}
